/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for updating a tunneled MCP server source
 */
export type UpdateTunneledMcpServerForm = {
  /**
   * Consent to serve this source through a public, anonymous MCP endpoint. Disabling revokes all live anonymous sessions. Omit to leave unchanged.
   */
  allowPublic?: boolean | undefined;
  /**
   * The ID of the tunneled MCP server to update
   */
  id: string;
  /**
   * Human-readable display name for the tunneled MCP server. Omit to leave unchanged.
   */
  name?: string | undefined;
  /**
   * Token-bucket capacity for public_request_rate_per_second: how many requests are admitted back-to-back from an idle tunnel before admission drops to the sustained rate. Each request takes one token; tokens refill at the sustained rate up to this cap. Omit to leave unchanged, 0 to clear (twice the sustained rate applies).
   */
  publicRequestBurst?: number | undefined;
  /**
   * Sustained anonymous MCP requests per second admitted when this source is served through a public MCP endpoint. Applies to every MCP interaction; one bucket is shared by every caller. Omit to leave unchanged, 0 to clear back to the deployment default.
   */
  publicRequestRatePerSecond?: number | undefined;
  /**
   * RFC 9728 protected resource identifier of the tunneled server, used for credential routing and as the signed caller assertion audience; never dialed by Speakeasy. The exact identifier is preserved, including trailing slashes. When unset, caller assertions use tunneled-mcp-server:<ID>. Pass an empty string to clear. Omit to leave unchanged.
   */
  resourceIdentifier?: string | undefined;
};

/** @internal */
export type UpdateTunneledMcpServerForm$Outbound = {
  allow_public?: boolean | undefined;
  id: string;
  name?: string | undefined;
  public_request_burst?: number | undefined;
  public_request_rate_per_second?: number | undefined;
  resource_identifier?: string | undefined;
};

/** @internal */
export const UpdateTunneledMcpServerForm$outboundSchema: z.ZodMiniType<
  UpdateTunneledMcpServerForm$Outbound,
  UpdateTunneledMcpServerForm
> = z.pipe(
  z.object({
    allowPublic: z.optional(z.boolean()),
    id: z.string(),
    name: z.optional(z.string()),
    publicRequestBurst: z.optional(z.int()),
    publicRequestRatePerSecond: z.optional(z.int()),
    resourceIdentifier: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      allowPublic: "allow_public",
      publicRequestBurst: "public_request_burst",
      publicRequestRatePerSecond: "public_request_rate_per_second",
      resourceIdentifier: "resource_identifier",
    });
  }),
);

export function updateTunneledMcpServerFormToJSON(
  updateTunneledMcpServerForm: UpdateTunneledMcpServerForm,
): string {
  return JSON.stringify(
    UpdateTunneledMcpServerForm$outboundSchema.parse(
      updateTunneledMcpServerForm,
    ),
  );
}
